import React from 'react';

const SideBarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9375 13.75H12.8125C15 13.75 15 13.75 15 11.125V8.875C15 6.25 15 6.25 12.8125 6.25H10.9375C8.75 6.25 8.75 6.25 8.75 8.875V11.125C8.75 13.75 8.75 13.75 10.9375 13.75Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.168 16.6673H5.83464C2.5013 16.6673 1.66797 15.834 1.66797 12.5007V7.50065C1.66797 4.16732 2.5013 3.33398 5.83464 3.33398H14.168C17.5013 3.33398 18.3346 4.16732 18.3346 7.50065V12.5007C18.3346 15.834 17.5013 16.6673 14.168 16.6673Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SideBarIcon;
